import { render, staticRenderFns } from "./IntroList.vue?vue&type=template&id=5d883010&"
import script from "./IntroList.vue?vue&type=script&lang=js&"
export * from "./IntroList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports